import Constants from "../services/constant";

export const getImageUrl = (img) => {
    if (img.includes("http")) {
        return img;
    } else {
        return Constants?.BASE_URL + img;
    }
};
